import initTrustedPlatforms from "../modules/trusted-platforms.js";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTrustedPlatforms);
} else {
  initTrustedPlatforms();
}
